import { render, staticRenderFns } from "./CallLogForm.vue?vue&type=template&id=c52d12be&"
import script from "./CallLogForm.vue?vue&type=script&lang=ts&"
export * from "./CallLogForm.vue?vue&type=script&lang=ts&"
import style0 from "./CallLogForm.vue?vue&type=style&index=0&id=c52d12be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports